// extracted by mini-css-extract-plugin
export var logo = "_id-2";
export var logoWrapper = "_id-1";
export var strip = "_id-0";